import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CarpenterIcon(props: IconProps) {
    return <Icon {...props} iconKey={"carpenter"}/>
}
